import { Route, Routes } from "react-router-dom";

import ChangePasswordPage from "components/pages/ChangePasswordPage";
import LoginPage from "components/pages/LoginPage";
import ResetPasswordPage from "components/pages/ResetPasswordPage";

const LoginRoutes = () => {
  return (
    <Routes>
      <Route
        key="/reset-password"
        path="/password-reset"
        element={<ResetPasswordPage />}
      />
      <Route
        key="/change-password"
        path="/password-reset/change-password/:uid/:token"
        element={<ChangePasswordPage />}
      />
      <Route key="/" path="*" element={<LoginPage />} />
    </Routes>
  );
};

export default LoginRoutes;
